import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './../styles/landing.css';
import { getAudioClipById } from '../api/apiClient';

const AudioClips = () => {
    const { id } = useParams();
    const [audioClipData, setAudioClipData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [audioError, setAudioError] = useState(null);

    useEffect(() => {
        const fetchAudioClipData = async () => {
            try {
                const data = await getAudioClipById(id);
                setAudioClipData(data);
                setError(null);
            } catch (err) {
                setError(err.message || 'Failed to fetch audio clip');
            } finally {
                setIsLoading(false);
            }
        };

        fetchAudioClipData();
    }, [id]);

    if (isLoading) {
        return <div className="loading">Loading audio clip</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    if (!audioClipData?.name) {
        return <div className="error">No audio clip found</div>;
    }

    const audioFileUrl = `/api/audio_clips/serve-audio/v1/${id}`;

    return (
        <div className="audio-clip-container">
            <div className="metadata">
                <h2>Play Audio Clip</h2>
                <p><strong>Filename:</strong> {audioClipData.name}</p>
                <p><strong>Transcription:</strong> {audioClipData.transcription}</p>
            </div>

            <div className="audio-player">
                <h3>Audio Player</h3>
                {audioError && <div className="error-message">Error loading audio: {audioError}</div>}
                <audio
                    controls
                    key={audioFileUrl}
                    onError={(e) => setAudioError("Failed to load audio file")}
                >
                    <source src={audioFileUrl} type="audio/wav" />
                    Your browser does not support the audio element.
                </audio>
            </div>
        </div>
    );
};

export default AudioClips;
